import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Credit } from '@models/index';

import { HttpService } from 'src/app/services/http.service';
import { EndpointParams } from '@models/utils/endpoint-params';

@Injectable({
    providedIn: 'root'
})
export class CreditsService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    private creditsSubject = new BehaviorSubject<Credit[]>([]);
    private isLoadingDataSubject = new BehaviorSubject<boolean>(true);
    private dataStore: { credits: Credit[] } = { credits: [] };

    get credits(): Observable<Credit[]> {
        return this.creditsSubject.asObservable();
    }

    get isLoading(): Observable<boolean> {
        return this.isLoadingDataSubject.asObservable();
    }

    list(): void {
        this.loading(true);
        this.listCredits().subscribe(
            () => {
                this.next([ ...this.dataStore.credits ]);
                this.loading(false);
            }
        );
    }

    search(idTransaction: string): Observable<Credit> {
        return this.get(`credits/member/${idTransaction}`, this.defaultEndpointParams).pipe(
            map(response => new Credit().build(response))
        );
    }

    private listCredits(): Observable<boolean> {
        return new Observable<boolean>(
            observable => {
                this.get('credits/member', this.defaultEndpointParams).subscribe(
                    data => {
                        console.log(data);
                        this.dataStore.credits = [];
                        data.forEach((credit: any) => {
                            this.dataStore.credits.push(new Credit().build(credit));
                        });

                        observable.next(true);
                    }, () => observable.next(false)
                );
            }
        );
    }

    private next(data: Credit[]): void {
        this.creditsSubject.next(data);
    }

    private loading(value: boolean): void {
        this.isLoadingDataSubject.next(value);
    }
}
